import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'la-thunderstorm',
  template: `
    <svg
        class="climacon climacon_cloudLightning"
        enable-background="new 15 15 70 70"
        id="cloudLightning"
        version="1.1"
        viewBox="15 15 70 70"
        x="0px"
        xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg"
        y="0px">
      <g class="climacon_iconWrap climacon_iconWrap-cloudLightning">
            <g class="climacon_wrapperComponent climacon_wrapperComponent-lightning">
                <polygon
                    class="climacon_component climacon_component-stroke climacon_component-stroke_lightning"
                    points="48.001,51.641 57.999,51.641 52,61.641 58.999,61.641 46.001,77.639 49.601,65.641 43.001,65.641 "/>
            </g>
        <g class="climacon_wrapperComponent climacon_wrapperComponent-cloud">
                <path
                    class="climacon_component climacon_component-stroke climacon_component-stroke_cloud"
                    d="M59.999,65.641c-0.28,0-0.649,0-1.062,0l3.584-4.412c3.182-1.057,5.478-4.053,5.478-7.588c0-4.417-3.581-7.998-7.999-7.998c-1.602,0-3.083,0.48-4.333,1.29c-1.231-5.316-5.974-9.29-11.665-9.29c-6.626,0-11.998,5.372-11.998,12c0,5.446,3.632,10.039,8.604,11.503l-1.349,3.777c-6.52-2.021-11.255-8.098-11.255-15.282c0-8.835,7.163-15.999,15.998-15.999c6.004,0,11.229,3.312,13.965,8.204c0.664-0.114,1.338-0.205,2.033-0.205c6.627,0,11.999,5.371,11.999,11.999C71.999,60.268,66.626,65.641,59.999,65.641z"/>
            </g>
        </g>
    </svg><!--cloudLightning -->
  `,
  styles: [`
    svg{shape-rendering:geometricPrecision}circle,g,path,rect{-webkit-transform-origin:50% 50%;transform-origin:50% 50%;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:linear;animation-timing-function:linear;-webkit-animation-duration:12s;animation-duration:12s;-webkit-animation-direction:normal;animation-direction:normal}.climacon_component-stroke_lightning{fill-opacity:0;-webkit-animation-name:thunderstorm-lightningFlash;animation-name:thunderstorm-lightningFlash;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-direction:normal;animation-direction:normal;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out;-webkit-animation-duration:12s;animation-duration:12s}.climacon_wrapperComponent-cloud{fill:#8c949a}.climacon_wrapperComponent-lightning{fill:#ffb22f}@-webkit-keyframes thunderstorm-lightningFlash{0%{fill-opacity:0;stroke-opacity:0}1%{fill-opacity:1;stroke-opacity:1}7%{fill-opacity:0;stroke-opacity:0}50%{fill-opacity:0;stroke-opacity:0}51%{fill-opacity:1;stroke-opacity:1}53%{fill-opacity:0;stroke-opacity:0}54%{fill-opacity:1;stroke-opacity:1}60%{fill-opacity:0;stroke-opacity:0}to{fill-opacity:0;stroke-opacity:0}}@keyframes thunderstorm-lightningFlash{0%{fill-opacity:0;stroke-opacity:0}1%{fill-opacity:1;stroke-opacity:1}7%{fill-opacity:0;stroke-opacity:0}50%{fill-opacity:0;stroke-opacity:0}51%{fill-opacity:1;stroke-opacity:1}53%{fill-opacity:0;stroke-opacity:0}54%{fill-opacity:1;stroke-opacity:1}60%{fill-opacity:0;stroke-opacity:0}to{fill-opacity:0;stroke-opacity:0}}
  `]
})
export class LaThunderstormComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
